module.exports = __webpack_public_path__ + "media/images/png/rent-white/5-1c82b64123503b083315769f12fed0b1.png";